import { Card, CardProps, Box } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import React, { useMemo } from "react";

export interface TagSkeletonCardProps extends CardProps {}

export function TagSkeletonCard(props: TagSkeletonCardProps) {
  const skeletonTitleWidth = useMemo(
    () => Math.floor(Math.random() * 100) + 70,
    [],
  );
  const skeletonDescriptionWidth = useMemo(
    () => Math.floor(Math.random() * 100) + 200,
    [],
  );
  return (
    <Card {...props}>
      <Box
        display={"flex"}
        alignItems="flex-start"
        padding={2}
        flexDirection={"column"}
        gap={1}
      >
        <Skeleton
          animation="wave"
          variant="rounded"
          width={`${skeletonTitleWidth}px`}
          height={28}
          sx={{ ml: 0.5, borderRadius: 4 }}
        />
        <Skeleton
          animation="wave"
          width={`${skeletonDescriptionWidth}px`}
          height={20}
          sx={{ ml: 0.5 }}
        />
      </Box>
    </Card>
  );
}
